import { render } from "./ModalComponent.vue?vue&type=template&id=22388547&ts=true"
import script from "./ModalComponent.vue?vue&type=script&lang=ts"
export * from "./ModalComponent.vue?vue&type=script&lang=ts"

import "./ModalComponent.vue?vue&type=style&index=0&id=22388547&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__